// MBK Internal GenAI Configuration
// Change these values for different deployments

export const CONFIG = {
  // AWS Region
  AWS_REGION: 'us-east-1',
  
  // Cognito Configuration
  USER_POOL_ID: 'us-east-1_j3P60cED6',
  CLIENT_ID: '2pco618qlb7o2r7spmb5j8iff0',
  IDENTITY_POOL_ID: 'us-east-1:b38ff660-8257-4bde-b2b5-43f5c9e1c88e',
  
  // Cognito Domain - works with all your domains
  COGNITO_DOMAIN: 'https://auth.tanisorn.work',
  
  // DynamoDB Table
  DYNAMODB_TABLE: 'mbk-chatbot-history',
  
  // S3 Bucket for file uploads
  S3_BUCKET: 'mbk-chatbot-files',
  
  // App Configuration
  APP_NAME: 'MBK Internal GenAI ✨',
  LOGO_PATH: '/mbk-logo.png',
  
  // Optional: Custom AWS Credentials (leave empty to use default)
  // Only use this if you need specific credentials
  AWS_CREDENTIALS: {
    // accessKeyId: 'your-access-key',
    // secretAccessKey: 'your-secret-key',
    // sessionToken: 'your-session-token' // optional
  }
};

// Deployment Instructions:
// 1. Update USER_POOL_ID, CLIENT_ID, IDENTITY_POOL_ID with your Cognito values
// 2. Update COGNITO_DOMAIN with your Cognito domain
// 3. Update DYNAMODB_TABLE with your table name
// 4. Update APP_NAME and LOGO_PATH if needed
// 5. Update AWS_REGION if deploying to different region
// 6. Optionally set AWS_CREDENTIALS if not using default credentials

// Supported URLs (configured in Cognito):
// - http://localhost:3000 (development)
// - https://d2vvmptsjb6dx1.cloudfront.net (CloudFront)
// - https://main.d1lq40h3bhsb4p.amplifyapp.com (Amplify)
// - https://mbk.tanisorn.work (custom domain)
